module.exports = "/assets/91115ec12578575bc14be0b8e9482c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XT.png
// module id = 2008
// module chunks = 0